export default {
      id: "custom-usage",
      viewBox: "0 0 31 18",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#custom-usage",
      toString: function () {
        return this.url;
      }
    }